<template>
  <div>
    <el-form size="small" label-width="100px" class="margin15-tb">
      <el-row :gutter="24">
        <el-col :span="5">
          <el-form-item label="标签名称">
            <el-input clearable v-model="label" placeholder="请输入标签" style="width: 100%;"/>
          </el-form-item>
        </el-col>
        <el-col :span="5">
          <el-form-item label="主策略">
            <el-select
              v-model="mainStrategy"
              clearable
              filterable
              allow-create
              default-first-option
              placeholder="请选择或输入主策略"
              style="width: 100%;">
              <el-option
                v-for="item in labelMainOption"
                :key="item.name"
                :label="item.name"
                :value="item.name">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="5">
          <el-form-item label="案件状态">
            <el-select
              v-model="caseStatus"
              clearable
              filterable
              allow-create
              default-first-option
              placeholder="请选择或输入案件状态"
              multiple
              collapse-tags
              style="width: 100%;">
              <el-option
                v-for="item in caseStatusOption"
                :key="item.modelName"
                :label="item.modelName"
                :value="item.modelName">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="5">
          <el-form-item label="开关">
            <el-select
              v-model="labelStatus"
              clearable
              filterable
              allow-create
              placeholder="请选择开关状态"
              style="width: 100%;">
              <el-option value="1" label="启用" key="1" ></el-option>
              <el-option value="0" label="禁用" key="0" ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="3">
          <div class="text right">
            <el-button type="primary" @click="search" :icon="'el-icon-search'">搜索</el-button>
            <el-button @click="resetSearch" :icon="'el-icon-refresh'">重置</el-button>
          </div>
        </el-col>
      </el-row>
    </el-form>
    <p>
      <el-button icon="el-icon-plus" type="primary" size="small" @click="add" v-if="this.$hasPerm('B008&3-1')">添加标签</el-button>

      <el-button type="success" size="mini" @click="exportExcel">导出Excel</el-button>
    </p>
    <div class="padding15-tb">
      <el-table
        :data="list"
        v-loading="loading"
        size="small"
        @sort-change="sortChange"
        style="width: 100% ">
        <el-table-column
          prop="name"
          label="标签名称"
          align="center"
          width="180">
        </el-table-column>
        <el-table-column
          prop="labelMain"
          align="center"
          sortable="custom"
          label="主策略">
        </el-table-column>
        <el-table-column
          prop="remark"
          align="center"
          label="描述">
        </el-table-column>
        <el-table-column
          prop="contactStatusStr"
          align="center"
          label="联系状态">
        </el-table-column>
        <el-table-column
          prop="caseStatusStr"
          align="center"
          sortable="custom"
          label="案件状态">
        </el-table-column>
        <el-table-column
          prop="priority"
          align="center"
          sortable="custom"
          label="语料优先级">
        </el-table-column>
        <el-table-column
          prop="platformPriority"
          align="center"
          sortable="custom"
          label="平台优先级">
        </el-table-column>
        <el-table-column
          label="操作"
          align="center"
          v-if="this.$hasPerm('B008&3-1')"
          width="120px">
          <template slot-scope="scope">
            <el-button type="text" size="medium" icon="el-icon-edit-outline" @click="edit(scope.row)"></el-button>
            &nbsp;
            <el-switch
              @change="updateStatus(scope.row)"
              v-model="scope.row.status">
            </el-switch>
          </template>
        </el-table-column>
      </el-table>
      <div class="text center margin15-tb">
        <el-pagination
          background
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="pageData.currentPage"
          :page-sizes="[50, 100, 200]"
          :page-size="pageData.pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="pageData.totalCount">
        </el-pagination>
      </div>
    </div>

    <!-- 添加标签 -->
    <el-dialog
      :visible.sync="addLabelVisible"
      :title="dialogTitle"
      center
      width="70%">
      <div>
        <el-form size="small" label-width="140px">
          <el-row :gutter="24">
            <el-col :span="12">
              <el-form-item label="标签名称">
                <el-input v-model="req.name" @blur="transmitLabelName" placeholder="请输入15字以内的标签内容" v-bind:disabled="isDisable"/>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="主策略">
                <el-select v-model="req.labelMain" style="width: 100%;" placeholder="请选择" filterable>
                  <el-option
                    v-for="item in labelMainOption"
                    :key="item.name"
                    :label="item.name"
                    :value="item.name">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="24">
            <el-col :span="12">
              <el-form-item label="语料优先级">
                <label-tree ref="labelTree" @initLabelData = 'initLabelData' @sendTarget = 'receiveTarget'></label-tree>
              </el-form-item>
            </el-col>

            <el-col :span="12">
              <el-form-item label="平台优先级">
                <el-input-number v-model="req.platformPriority" placeholder="请输入语料优先级" :min="1" :max="10" v-bind:disabled="isDisable"/>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="24">
            <el-col :span="12">
              <el-form-item label="标签描述">
                <el-input v-model="req.remark" type="textarea" resize="none" placeholder="请输入标签描述" :rows="4" v-bind:disabled="isDisable"/>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="24">
            <el-col :span="12">
              <el-form-item label="联系状态">
                <el-select v-model="req.contactStatus" style="width: 100%;" placeholder="请选择" filterable v-bind:disabled="isDisable">
                  <el-option
                    v-for="item in contactStatusOption"
                    :key="item.modelCode"
                    :label="item.modelName"
                    :value="item.modelCode">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="案件状态">
                <el-select v-model="req.caseStatus" style="width: 100%;" placeholder="请选择" filterable v-bind:disabled="isDisable">
                  <el-option
                    v-for="item in caseStatusOption"
                    :key="item.modelName"
                    :label="item.modelName"
                    :value="item.modelName">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="addLabelVisible = false" size="small">取 消</el-button>
        <el-button type="primary" @click="addOrEdit" size="small">保存</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import labelTree from '../../ztree/treeDemo';


export default {
  props: {
    caseStatusOption: {
      type: Array
    },
    contactStatusOption: {
      type: Array
    },
    labelMainOption: {
      type: Array
    },
    getLabelParams: {
      type: Function,
      default() {
      }
    },
    changeTabe: {
      type: String
    },
    companySelected: {
    }
  },
  watch: {
    changeTabe(type) {
      if (type === '标签列表') {
        if (this.companyId !== '') {
          this.getData(1);
        }
      }
    },
    companySelected(companyId) {
      this.companyId = companyId;
      if (this.changeTabe === '标签列表') {
        this.getData(1);
      }
    }
  },
  data() {
    return {
      loading: true,
      dialogTitle: '',
      addLabelVisible: false,
      list: [],
      pageData: {},
      companyId: '',
      label: '',
      mainStrategy: '',
      caseStatus: [],
      labelStatus: null,
      strategiesOption: [
        {
          value: 'sent',
          label: '首次发送'
        },
        {
          value: 'call',
          label: '客户回拨'
        }
      ],
      req: {
        id: '',
        name: '',
        priority: '',
        platformPriority: '',
        labelMain: '',
        remark: '',
        caseStatus: '',
        contactStatus: '',
        companyId: '',
        status: '',
        targetId: null,
        targetType: null
      },
      sort: {
        order: '',
        sort: ''
      },
      defaultSort: {
        order: 'platformPriority',
        sort: 'desc'
      },
      isDisable: false,
      isCanEditPriority: false,
      nodeId: null,
      orderNum: null,
      isCanEdit: false
    };
  },
  components: {
    labelTree
  },
  methods: {
    getData(page) {
      this.loading = true;
      this.$ajax({
        url: '/label/list',
        method: 'POST',
        data: this.getSearchParam(page)
      }).then((res) => {
        this.list = [];
        this.list = res.data.list;
        this.pageData.pageSize = res.data.limit;
        this.pageData.totalCount = res.data.totalRecords;
        this.pageData.currentPage = res.data.currentPage;
        this.loading = false;
      });
    },
    getSearchParam(page) {
      const req = {
        'companyId': this.companyId,
        'label': this.label,
        'mainStrategy': this.mainStrategy,
        'caseStatusList': this.caseStatus,
        'labelStatus': this.labelStatus,
        'page': page,
        'limit': this.pageData.pageSize || 50,
        'order': this.sort.order || this.defaultSort.order,
        'sort': this.sort.sort || this.defaultSort.sort
      };
      return req;
    },
    getDataByFirst(companyId, page) {
      this.companyId = companyId;
      this.getData(page);
    },
    // 每页条数
    handleSizeChange(val) {
      this.pageData.pageSize = val;
      this.getData(1);
    },
    // 页码
    handleCurrentChange(val) {
      this.pageData.currentPage = val;
      this.getData(val);
    },
    search() {
      this.getData(1);
    },
    exportExcel() {
      this.$download({
        url: '/strategy/excel/exportLabels',
        method: 'POST',
        data: this.getSearchParam(1),
        name: '标签列表.xlsx'
      });
    },
    add() {
      this.dialogTitle = '添加标签';
      this.addLabelVisible = true;
      this.req = {
        id: '',
        name: '',
        priority: '',
        platformPriority: '',
        labelMain: '',
        remark: '',
        caseStatus: '',
        contactStatus: '',
        companyId: '',
        status: '',
        targetId: null,
        targetType: null
      };
      this.nodeId = null;
      this.orderNum = null;
      this.isDisable = false;
      this.isCanEditPriority = true;
      this.isCanEdit = true;
      this.$refs.labelTree.getLabelPriorityInfo(this.companyId);
    },
    edit(row) {
      this.dialogTitle = '编辑标签';
      this.addLabelVisible = true;
      this.req = {
        id: row.id,
        name: row.name,
        priority: row.priority,
        platformPriority: row.platformPriority,
        labelMain: row.labelMain,
        remark: row.remark,
        caseStatus: row.caseStatusStr,
        contactStatus: row.contactStatus,
        companyId: row.companyId,
        status: row.status,
        targetId: null,
        targetType: null
      };
      this.isDisable = !row.isCanEdit;
      this.isCanEditPriority = row.isCanEditPriority;
      this.nodeId = row.id;
      this.orderNum = row.priority;
      this.isCanEdit = row.isCanEdit;
      this.$refs.labelTree.getLabelPriorityInfo(this.companyId, row.id, row.priority, row.isCanEdit, row.isCanEditPriority);
    },
    addOrEdit() {
      if (!this.checkAddOrEditParmas()) return;
      this.req.status = true;
      this.req.companyId = this.companyId;
      this.$ajax({
        url: '/label/addOrEditLabel',
        prompt: true,
        method: 'POST',
        data: this.req
      }).then(() => {
        this.addLabelVisible = false;
        this.search();
        this.getLabelParams();
      });
    },
    checkAddOrEditParmas() {
      if (!this.req.name) {
        this.$message({
          message: '请输入标签名称',
          type: 'warning'
        });
        return false;
      }
      // if (!this.req.priority) {
      //   this.$message({
      //     message: '请输入语料优先级',
      //     type: 'warning'
      //   });
      //   return false;
      // }
      if (!this.req.platformPriority) {
        this.$message({
          message: '请输入平台优先级',
          type: 'warning'
        });
        return false;
      }
      if (!this.req.remark) {
        this.$message({
          message: '请输入标签描述',
          type: 'warning'
        });
        return false;
      }
      if (!this.req.contactStatus) {
        this.$message({
          message: '请选择联系状态',
          type: 'warning'
        });
        return false;
      }
      if (!this.req.caseStatus) {
        this.$message({
          message: '请选择案件状态',
          type: 'warning'
        });
        return false;
      }
      if (!this.req.labelMain) {
        this.$message({
          message: '请选择主策略',
          type: 'warning'
        });
        return false;
      }
      return true;
    },
    updateStatus(row) {
      this.$ajax({
        url: '/label/updateLabelStatus',
        prompt: true,
        method: 'POST',
        data: { 'id': row.id, 'status': row.status, 'companyId': row.companyId }
      }).then(() => {
        this.getLabelParams();
      }).catch(() => {
        row.status = !row.status;
      });
    },
    sortChange(data) {
      if (!data.prop) {
        return;
      }
      this.sort.order = data.prop;
      if (data.order === 'ascending') {
        this.sort.sort = 'asc';
      } else {
        this.sort.sort = 'desc';
      }
      this.getData(1);
    },
    transmitLabelName() {
      this.$refs.labelTree.getLabelName(this.req.name);
    },
    initLabelData() {
      this.$refs.labelTree.getLabelPriorityInfo(this.companyId, this.nodeId, this.orderNum, this.isCanEdit, this.isCanEditPriority);
    },
    receiveTarget(targetId, targetType) {
      this.req.targetId = targetId;
      this.req.targetType = targetType;
    },
    resetSearch() {
      this.label = '';
      this.mainStrategy = '';
      this.caseStatus = [];
      this.labelStatus = '';
      this.getData(1);
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/page/main/collection/engine/label_list.vue